// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__kzqzS","name":"styles_name__16y5A","checkbox":"styles_checkbox__wNvg1","date":"styles_date__11O44","status":"styles_status__1EOw9"};